import React, { useState } from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';

import Card from '../../Card';
import Drawer from '../../Drawer';
import BackButton from '../../common/BackButton';
import { INTRO_HINT_SELECTORS } from '../../common/Intro';
import Avatar from '../../Avatar';
import SurveyListButton from '../SurveyListButton';
import SurveyResultList from '../SurveyResultList';
import { ACTIONS } from '../../../constants/strings';
import { SURVEYS_LIST_TYPE } from '../../../constants';
import { COLORS } from '../../../constants/styles';
import { enhance } from './enhance';

const drawerStyle = {
  color: COLORS.grayDark,
  padding: 16,
};

const drawerContStyle = {
  flexGrow: 0,
  flexShrink: 1,
};

const buttonBackgroundStyle = {
  background: COLORS.blueGrayish,
  marginLeft: '-16px',
  marginRight: '-16px',
  padding: '24px 16px',
};

const SurveysDrawer = ({
  onBack,
  upcomingList,
  upcomingListCounter,
  isSending,
  onSurveyResultsClick,
  onSurveyListClick,
  surveyId,
  answeredList,
  formatMessage,
  userComplementary,
  userAvatar,
  userName,
  contextId,
  loadNextAnsweredRequests,
  isProvider,
  canEdit,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);
  const hasUpcomingSurveys = isArray(upcomingList) && !isEmpty(upcomingList);

  const handleClick = type => {
    setSelectedButton(type);
    onSurveyListClick(type);
  };

  const handleResultListClickItem = id => {
    setSelectedButton(SURVEYS_LIST_TYPE.RESULTS);
    onSurveyResultsClick(SURVEYS_LIST_TYPE.RESULTS, id);
  };

  const handleLoadMore = () => {
    loadNextAnsweredRequests({
      id: contextId,
      limit: 10,
    });
  };

  return (
    <Drawer
      className="bg-white-90"
      opened
      scrollable={false}
      width={300}
      style={drawerStyle}
    >
      <div className="flex flex-column h-100">
        <div style={drawerContStyle}>
          <BackButton onBack={onBack} />
          <Card
            className="fw6 f5 pv3"
            text={{
              primary: userName,
              complementary: userComplementary,
              intro: INTRO_HINT_SELECTORS.patient.messages.patientContext,
            }}
            additionalContent={{
              left: <Avatar children={userName} size={52} src={userAvatar} />,
            }}
          />
          <If condition={(isProvider || canEdit) && hasUpcomingSurveys}>
            <div style={buttonBackgroundStyle}>
              <SurveyListButton
                onClick={() => handleClick(SURVEYS_LIST_TYPE.UPCOMING)}
                badge={upcomingListCounter}
                text={formatMessage(ACTIONS.survey.upcoming)}
                disabled={isSending}
                active={selectedButton === SURVEYS_LIST_TYPE.UPCOMING}
              />
            </div>
          </If>
        </div>
        <SurveyResultList
          onClickItem={handleResultListClickItem}
          answeredList={answeredList}
          surveyId={
            selectedButton === SURVEYS_LIST_TYPE.RESULTS ? surveyId : null
          }
          toggle
          sending={isSending}
          loadMore={handleLoadMore}
        />
      </div>
    </Drawer>
  );
};

SurveysDrawer.propTypes = {
  isSending: PropTypes.bool,
  isProvider: PropTypes.bool,
  canEdit: PropTypes.bool,
  upcomingListCounter: PropTypes.number,
  answeredList: PropTypes.array,
  upcomingList: PropTypes.array,
  onBack: PropTypes.func,
  surveyId: PropTypes.number,
  formatMessage: PropTypes.func.isRequired,
  loadNextAnsweredRequests: PropTypes.func.isRequired,
  userComplementary: PropTypes.string,
  userAvatar: PropTypes.string,
  userName: PropTypes.string,
  onSurveyResultsClick: PropTypes.func,
  onSurveyListClick: PropTypes.func,
  contextId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default enhance(SurveysDrawer);



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveysDrawer/index.jsx